import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Logo from '../src/assets/LOGOTIPO-GKM.png';

const NavbarPage = () => {
    const navigate = useNavigate();
    const [activaLogout, setActivaLogout] = useState(false);
    useEffect(() => {
        const token = localStorage.getItem('token');  // Asumiendo que el token está en localStorage
        //console.log(token)
        if (token!=null) {
            setActivaLogout(true);
        }else{
            setActivaLogout(false);
        }
    }, [navigate]);

  const handleLogout = () => {
    // Eliminar el token de autenticación (por ejemplo, del localStorage)
    localStorage.removeItem('token'); // O sessionStorage.removeItem('token');

    // Redirigir al usuario a la página de inicio de sesión o cualquier otra página
    navigate('/login');
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="navbar-custom">
      <Container>
        <Navbar.Brand href="/">
          <img src={Logo} style={{ width: 100 }} alt="Grekad" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/ingreso">Votar</Nav.Link>
            <Nav.Link href="/ranking">Ranking</Nav.Link>
            <Nav.Link href="/statistics">Estadistica</Nav.Link>
          </Nav>
          <Nav className="ms-auto">
            {activaLogout===true?(<Button variant="outline-light" onClick={handleLogout}>
              Cerrar sesión
            </Button>):('')
            }
          </Nav>
          <Nav  className="ms-auto">
            <Nav.Link href="https://www.grekadmet.cl" rel="noopener noreferrer">
              Volver al sitio
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarPage;